import React from 'react'
import { connect } from 'react-redux'
import { Segment } from 'semantic-ui-react'
import { LKHeader } from 'loankeeper-common/components'
import { colors } from 'shared'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import { FakeInput } from 'shared/StyledComponents'
import Modals from './Modals'
import { translateCmd } from '../../../helpers'
import RelationsGrid from './RelationsGrid'
import ClientSearchModal from './ClientSearchModal'
import AddRelationModal from './AddRelationModal'
import { clientSearchModal, addRelationModal } from '../../../constants'
import AddClientForm, { AddClientFormTrigger } from '../../../../ClientForm'
import { loadClientDetails } from '../../../../../store/client'
import { RelationsProps } from 'src/features/ClientDetails/types'

//@ts-ignore
@connect(undefined, {
  openClientSearch: () => LKModalActions.open({ name: clientSearchModal }),
  openAddRelationModal: (row: { Full_Name: string; ID: number; HashSum_ClientID_: string }) =>
    LKModalActions.open({ name: addRelationModal, row }),
  loadClientDetails,
})
class Relations extends React.PureComponent<RelationsProps> {
  static defaultProps = {
    data: [],
  }

  handleClientAdd = async ({ ClientID, HashSum_ClientID_ }: { ClientID: number; HashSum_ClientID_: string }) => {
    const clientDetailsResult = await this.props.loadClientDetails({
      clientId: ClientID,
      clientHash: HashSum_ClientID_,
    })

    if (loadClientDetails.fulfilled.match(clientDetailsResult)) {
      const client = clientDetailsResult.payload

      this.props.openAddRelationModal({ Full_Name: client.FullName, ID: ClientID, HashSum_ClientID_ })
    }
  }

  render() {
    const {
      ID,
      hash,
      base: { FullName },
      data,
      openClientSearch,
      instanceName,
    } = this.props

    return (
      <>
        <Modals />
        {/* @ts-ignore */}
        <AddRelationModal ID={ID} hash={hash} fullName={FullName} />
        <ClientSearchModal />
        <AddClientForm name="AddClientModal" onClientAddEdit={this.handleClientAdd} />

        <div className="u-fluid u-flex u-directionColumn">
          <div className="u-fluid u-relative u-flex">
            {/* @ts-ignore */}
            <RelationsGrid rowData={data} instanceName={instanceName} />
          </div>

          <div className="u-padding-5 u-flex u-directionRow u-spaceBetween">
            <div>
              <LKButton alias="attach" onClick={openClientSearch} permission="ADD_CLIENT_RELATIONS">
                {translateCmd('client_rl_add')}
              </LKButton>

              <AddClientFormTrigger clientType={1} groupid={4} permission="ADD_CLIENT_RELATIONS">
                {translateCmd('add_related_client')}
              </AddClientFormTrigger>
            </div>

            <FakeInput style={{ width: 150, textAlign: 'center' }}>
              <Segment>
                <LKHeader size="small" style={{ color: colors.red, fontWeight: 'bold' }}>
                  {data && data.length && data[0].GroupPortfolio}
                </LKHeader>
              </Segment>
            </FakeInput>
          </div>
        </div>
      </>
    )
  }
}

export default Relations
